import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {

  public l_userFullName: string = '';

  constructor() { }

  ngOnInit(): void {
    this.l_userFullName = sessionStorage.getItem('full_name') || '';
  }

}
